export enum Sizes {
    LARGE = 'large',
    SMALL = 'small',
    DEFAULT = 'default'
    // Add more sizes
}